SppHandler = App.loadClass 'grower::handlers/placement/SppHandler'

class exports.RuppGoodYieldsHandler extends SppHandler

    init: () ->
        @customButtons = [
            {
                'html': '<button class="btn btn-primary pull-left" id="pdf_button"
                        data-loading-text="Generating report..."
                    >
                        <i class="fa fa-file-o"></i> Summary Report
                    </button>'
                'click': () =>
                    layers = @curStep.stepKO.plantingPlans()
                    @actionPdf(layers)
            }
            {
                'html': '<button class="btn btn-blue pull-right">
                        <i class="fa fa-chevron-right"></i> Place Order
                    </button>'
                'click': () =>
                    hybrid_list = []
                    for v in @curStep.selectionsKO.hybrids()
                        hybrid_list.push
                            hybrids_id: v.id
                            treatments_id: v.treatmentID
                            qty: v.units

                    # create the Orders handler
                    order = @curStep.createSubHandler 'grower::handlers/rupp_orders/RuppOrdersDialogHandler'
                    if order
                        order.saveData =
                            crops_id: @cropID
                            lines: hybrid_list

                        order.loadLayoutPostOptions = 'crops_id': @cropID
                        order.init()

                        App.sidebar.close()
            }
        ]

        super()

    # This function will be passed into the Planting dialog controller via
    # PlantingOptions. "plan" is the Layer model used for the Plan tab.
    # "notes_obj" is the object used by the Notes tab.
    customPlantingPlan: (field_id, plan, notes_obj) =>
        products = @taffyObjects.hybrids

        @_customProductSubscription = (stage, product_id) ->
            product = products(id: parseInt(product_id)).first()
            stage.treatment = product?.default_treatment_id

            notesFn()

        notesFn = () ->
            notes = ''
            for event in plan.events
                for stage in event.stages
                    product = products(id: parseInt(stage.product?.id)).first()
                    if not product or not product.description
                        continue

                    notes += product.display_name
                    # url = product.tech_sheet_url
                    # notes += " (<a href='#{url}'>#{url}</a>)" if url
                    notes += '<br>'

                    if product.description
                        notes += product.description + '<br/>'

            notes_obj.notes = notes
